/** Five minutes, the firewall poll window. A check-in this old is unreachable. */
export const MESH_FRESH_MS = 5 * 60 * 1000;

export type MeshStanding = "not_enrolled" | "applied" | "pending" | "unreachable";

/**
 * No `meshSeenAt` is not enrolled. A check-in at or older than five minutes is
 * unreachable, even when `meshPending` is set. Inside the window, pending wins
 * over applied.
 */
export function meshStanding(
  server: { meshSeenAt?: string | null; meshPending?: boolean | null } | null | undefined,
  now = Date.now(),
): MeshStanding {
  const seen = server?.meshSeenAt;
  if (typeof seen !== "string" || seen.length === 0) return "not_enrolled";
  const seenAt = Date.parse(seen);
  if (!Number.isFinite(seenAt)) return "not_enrolled";
  if (now - seenAt >= MESH_FRESH_MS) return "unreachable";
  if (server?.meshPending === true) return "pending";
  return "applied";
}
